import {
  SET_REPORT_FILTERS,
  UPDATE_REPORT_FILTER,
  RESET_REPORT_FILTERS
} from '../Types';

/**
 * Default filter configuration for each report type
 */
const defaultFilters = {
  dailyInventoryDistribution: {
    dateRange: {
      initialDate: null,
      finalDate: null
    },
    groupByNit: false,
    onlyActive: true,
    nitList: [],
    articleType: [],
    category: [],
    sortBy: 'RecordDate',
    order: 'DESC'
  },
  providerInventoryDetail: {
    nit: '1',
    nitList: [],
    dateRange: {
      initialDate: null,
      finalDate: null
    },
    groupByNit: false,
    onlyActive: true
  }
};

/**
 * Report filters reducer
 * @param {Object} state - Current state
 * @param {Object} action - Action object
 * @returns {Object} New state
 */
function reportFiltersReducer(state = {}, action) {
  switch (action.type) {
    case SET_REPORT_FILTERS:
      return {
        ...state,
        [action.payload.reportType]: {
          ...defaultFilters[action.payload.reportType],
          ...action.payload.filters
        }
      };

    case UPDATE_REPORT_FILTER:
      return {
        ...state,
        [action.payload.reportType]: {
          ...(state[action.payload.reportType] || defaultFilters[action.payload.reportType]),
          [action.payload.key]: action.payload.value
        }
      };

    case RESET_REPORT_FILTERS:
      return {
        ...state,
        [action.payload]: defaultFilters[action.payload] || {}
      };

    default:
      return state;
  }
}

export default reportFiltersReducer;
